import React from 'react';
import BaseScreeningRTIComparisonModal from './BaseScreeningRTIComparisonModal';
import {
  getStudentsBySchoolId,
  getIndividualStudentResults
} from '../services/APIClient';

// All the logic and UI is inside BaseScreeningRTIComparisonModal now.
const RTIComparisonModal = ({ show, onHide, schoolid }) => (
  <BaseScreeningRTIComparisonModal
    show={show}
    onHide={onHide}
    schoolid={schoolid}
    getStudentsBySchoolId={getStudentsBySchoolId}
    getIndividualStudentResults={getIndividualStudentResults}
  />
);

export default RTIComparisonModal;
